'use strict';

var banks = angular.module('gymsystem.banks', []);

// http://www.bgc.se/globalassets/dokument/anvandarmanualer/bankernaskontonummeruppbyggnad_anvandarmanual_sv.pdf
banks.factory('banks', [function() {
    var banks = {};

    banks.list = [
        { name: 'Svea Bank AB', from: 9660, to: 9669, type: 1, subtype: 2 },
        { name: 'Aion Bank SA', from:  9580, to: 9589, type: 1, subtype: 1 },
        { name: 'Avanza Bank AB', from: 9550, to: 9569, type: 1, subtype: 2 },
        { name: 'BlueStep Finans AB', from: 9680, to: 9689, type: 1, subtype: 1 },
        { name: 'BNP Paribas SA., Sverige filial', from: 9470, to: 9479, type: 1, subtype: 2 },
        { name: 'Citibank', from: 9040, to: 9049, type: 1, subtype: 2 },
        { name: 'Danske Bank', from: 1200, to: 1399, type: 1, subtype: 1 },
        { name: 'Danske Bank', from: 2400, to: 2499, type: 1, subtype: 1 },
        { name: 'DNB Bank', from: 9190, to: 9199, type: 1, subtype: 2 },
        { name: 'DNB Bank', from: 9260, to: 9269, type: 1, subtype: 2 },
        { name: 'Ekobanken', from: 9700, to: 9709, type: 1, subtype: 2 },
        { name: 'Erik Penser AB', from: 9590, to: 9599, type: 1, subtype: 2 },
        { name: 'ICA Banken AB', from: 9270, to: 9279, type: 1, subtype: 1 },
        { name: 'IKANO Bank', from: 9170, to: 9179, type: 1, subtype: 1 },
        { name: 'JAK Medlemsbank', from: 9670, to: 9679, type: 1, subtype: 2 },
        { name: 'Klarna Bank', from: 9780, to: 9789, type: 1, subtype: 2 },
        { name: 'Landshypotek AB', from: 9390, to: 9399, type: 1, subtype: 2 },
        { name: 'Lunar Bank A/S', from: 9710, to: 9719, type: 1, subtype: 2 },
        { name: 'Lån & Spar Bank Sverige', from: 9630, to: 9639, type: 1, subtype: 1 },
        { name: 'Länsförsäkringar Bank', from: 3400, to: 3409, type: 1, subtype: 1 },
        { name: 'Länsförsäkringar Bank', from: 9020, to: 9029, type: 1, subtype: 2 },
        { name: 'Länsförsäkringar Bank', from: 9060, to: 9069, type: 1, subtype: 1 },
        { name: 'Marginalen Bank', from: 9230, to: 9239, type: 1, subtype: 1 },
        { name: 'Multitude Bank plc', from: 9070, to: 9079, type: 1, subtype: 1 },
        { name: 'NOBA Bank Group AB', from: 9640, to: 9649, type: 1, subtype: 2 },
        { name: 'Nordea', from: 1100, to: 1199, type: 1, subtype: 1 },
        { name: 'Nordea', from: 1400, to: 2099, type: 1, subtype: 1 },
        { name: 'Nordea', from: 3000, to: 3299, type: 1, subtype: 1 },
        { name: 'Nordea', from: 3301, to: 3399, type: 1, subtype: 1 },
        { name: 'Nordea', from: 3410, to: 3781, type: 1, subtype: 1 },
        { name: 'Nordea', from: 3783, to: 3999, type: 1, subtype: 1 },
        { name: 'Nordea', from: 4000, to: 4999, type: 1, subtype: 2 },
        { name: 'Nordnet Bank', from: 9100, to: 9109, type: 1, subtype: 2 },
        { name: 'Northmill Bank AB', from: 9750, to: 9759, type: 1, subtype: 2 },
        { name: 'Resurs Bank', from: 9280, to: 9289, type: 1, subtype: 1 },
        { name: 'Riksgälden', from: 9880, to: 9889, type: 1, subtype: 2 },
        { name: 'Santander Consumer Bank AS', from: 9460, to: 9469, type: 1, subtype: 1 },
        { name: 'SBAB', from: 9250, to: 9259, type: 1, subtype: 1 },
        { name: 'SEB', from: 5000, to: 5999, type: 1, subtype: 1 },
        { name: 'SEB', from: 9120, to: 9124, type: 1, subtype: 1 },
        { name: 'SEB', from: 9130, to: 9149, type: 1, subtype: 1 },
        { name: 'Skandiabanken', from: 9150, to: 9169, type: 1, subtype: 2 },
        { name: 'Swedbank', from: 7000, to: 7999, type: 1, subtype: 1, maxClearingLength: 4 },
        { name: 'Ålandsbanken Sverige AB', from: 2300, to: 2399, type: 1, subtype: 2 },
        { name: 'Danske Bank', from: 9180, to: 9189, type: 2, subtype: 1 },
        { name: 'Handelsbanken', from: 6000, to: 6999, type: 2, subtype: 2, accountNumberLength: [8, 9] },
        { name: 'Nordea/Plusgirot', from: 9500, to: 9549, type: 2, subtype: 3 },
        { name: 'Nordea/Plusgirot', from: 9960, to: 9969, type: 2, subtype: 3 },
        { name: 'Nordea - personkonto', from: 3300, to: 3300, type: 2, subtype: 1 },
        { name: 'Nordea - personkonto', from: 3782, to: 3782, type: 2, subtype: 1 },
        { name: 'Riksgälden', from: 9890, to: 9899, type: 2, subtype: 1 },
        { name: 'Swedbank', from: 9300, to: 9329, type: 2, subtype: 1 },
        { name: 'Swedbank', from: 9330, to: 9349, type: 2, subtype: 1 },
        { name: 'Sparbanken Syd', from: 9570, to: 9579, type: 2, subtype: 1 },
        { name: 'Swedbank', from: 8000, to: 8999, type: 2, subtype: 3, wrongCheck: true }
    ];

    var getFirstFour = function(x) {
        return String(x).substring(0,4);
    };

    banks.getBank = function(clearingNumber) {
        clearingNumber = Number(getFirstFour(clearingNumber));
        for (var i=0; i < banks.list.length; ++i) {
            var bank = banks.list[i];
            if (clearingNumber >= bank.from && clearingNumber <= bank.to) {
                return bank;
            }
        }
    };

    var checkMod11 = function(x) {
        x = String(x);
        var sum = 0;
        var weight = 1;
        for (var i=0; i < x.length; ++i) {
            var pos = x.length-i-1;
            var num = Number(x[pos]);
            sum += weight * num;
            ++weight;
            if (weight > 10) {
                weight = 1;
            }
        }

        return (sum % 11) == 0;
    };

    var checkMod10 = function(x) {
        x = String(x);
        var sum = 0;
        for (var i=0; i < x.length; ++i) {
            var pos = x.length-i-1;
            var num = Number(x[pos]);
            var weight = (i % 2) == 0 ? 1 : 2;
            var c = num * weight;
            sum += Math.floor(c / 10) + (c % 10);
        }

        return (sum % 10) == 0;
    };

    var getSecondToFourth = function(x) {
        x = String(x);
        return x.substring(1, 4);
    };

    var getLast = function(howMany, x) {
        x = String(x);
        return x.substring(x.length - howMany);
    };

    banks.validateAccountNumber = function(clearingNumber, accountNumber) {
        var bank = banks.getBank(clearingNumber);
        if (bank) {

            var accountNumberLength = String(accountNumber).length;
            if (accountNumberLength > 12) {
                return false;
            }

            if (bank.wrongCheck) {
                return true;
            }


            if (bank.type == 1) {
                accountNumber = String(accountNumber);  // account number can start with 00
                while(accountNumber.length < 7) {
                    accountNumber = '0' + accountNumber;
                }

                if (bank.subtype == 1) {
                    var check = getSecondToFourth(clearingNumber) + getLast(7, accountNumber);
                    return checkMod11(check);
                } else if (bank.subtype == 2) {
                    var check = getFirstFour(clearingNumber) + getLast(7, accountNumber);
                    return checkMod11(check);
                }
            } else if (bank.type == 2) {
                if (bank.subtype == 1) {
                    if (accountNumberLength != 10) {
                        return false;
                    }

                    var check = getLast(10, accountNumber);
                    return checkMod10(check);
                } else if (bank.subtype == 2) {
                    if(bank.accountNumberLength) {
                        if(bank.accountNumberLength.indexOf(accountNumberLength) === -1) {
                            return false;
                        }
                    } else if (accountNumberLength != 9) {
                        return false;
                    }

                    var check = getLast(9, accountNumber);
                    return checkMod11(check);
                } else if (bank.subtype == 3) {
                    if (accountNumberLength > 10) {
                        return false;
                    }

                    var check = getLast(10, accountNumber);
                    return checkMod10(check);
                }
            }

            return false;
        }
    };

    return banks;
}]);

banks.directive('clearingNumber', ['banks', function(banks) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {

            ctrl.$parsers.unshift(function(viewValue) {
                var bank = banks.getBank(viewValue);
                var valid = !viewValue || Boolean(bank);

                ctrl.$setValidity('clearingNumber', valid);
                return valid ? viewValue : undefined;
            });
        }
    };
}]);

banks.directive('bankAccountNumber', ['$parse', 'banks', function($parse, banks) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {

            ctrl.$parsers.unshift(function(viewValue) {
                var clearingNumber = $parse(attrs.bankAccountNumber)(scope);
                var validAccount = banks.validateAccountNumber(clearingNumber, viewValue);
                var valid = !viewValue || validAccount;

                ctrl.$setValidity('bankAccountNumber', valid);
                return valid ? viewValue : undefined;
            });
        }
    };
}]);

banks.directive('bankAccountNumber2', ['$parse', 'banks', function($parse, banks) {
    return {
        link: function(scope, els, attrs) {
            var el = els[0];
            $(el).addClass('ng-dirty');
            var field = $parse(attrs.bankAccountNumber2)(scope);

            if(!field.getClearingNumber) {
                console.error('field.getClearingNumber is required');
                return;
            }

            var clearingNumber, account, changed;
            var control = {
                $name: field.name,
                $error: {
                    bankAccountNumber: false
                },
                $setPristine: angular.noop
            };

            scope.innerForm.$addControl(control);

            var requiredError = {
                $error: {
                    required: [{$name: field.name}]
                },
                $setPristine: angular.noop
            };

            scope.$on('$destroy', function () {
                if (scope.innerForm) {
                    scope.innerForm.$removeControl(control);
                }
                scope?.form?.$setValidity?.('required', true, requiredError);
            });

            function setValue(status) {
                if(field.required && scope.form) {
                    scope.form.$setValidity('required', account, requiredError);
                }
                scope.innerForm.$setValidity('bankAccountNumber', status, control);
                control.$error.bankAccountNumber = !status;
                if(status) {
                    if(account) {
                        $(el).addClass('ng-valid');
                    }
                    $(el).removeClass('ng-invalid');
                } else {
                    $(el).addClass('ng-invalid');
                    $(el).removeClass('ng-valid');
                }

                if(field.value !== account) {
                    field.value = account;
                    if(field.change) {field.change();}
                }
                if(!scope.$root.$$phase) {scope.$apply();}
            }

            function apply() {
                if(!isFinite(account)) {
                    if(!field.required) {
                        setValue(true);
                        return;
                    } else {
                        if(!changed && !account) {
                            setValue(true);
                        } else {
                            setValue(false);
                        }
                        return;
                    }
                }

                if(!isFinite(clearingNumber)) {
                    setValue(false);
                    return;
                }

                if(banks.validateAccountNumber(clearingNumber, account)) {
                    setValue(true);
                } else {
                    setValue(false);
                }
            }

            function fieldValueChanged(value) {
                if(account == value) {return;}
                el.value = account = value;
                apply();
            }
            if(field.value) {fieldValueChanged(field.value);}

            scope.$watch(function() {return field.getClearingNumber();}, function(value) {
                clearingNumber = value;
                apply();
            });
            scope.$watch(function() {return field.value;}, fieldValueChanged);

            el.addEventListener('input', function() {
                changed = true;
                account = el.value===''?null:el.value;  //  need zeros at start, e.g. 9570-0040014714
                apply();
            });

        }
    };
}]);
